<template>
  <div class="flex-grow flex flex-col p-6 relative pb-8 bg-onboarding_gray text-white">
    <Logo class="self-start text-left mt-6 w-64 cursor-pointer" @click="$router.go(-1)"/>
    <div class="flex flex-col flex-grow justify-center gap-4">
      <div class="text-2xl leading-8 text-black font-thin text-left text-white">
        <p class="font-normal">Aumenta</p>
        <p class="mt-2">hasta un 40% tu</p>
        <p class="mt-2 text-SFRed">facturación</p>
      </div>
      <h4 class="text-left text-xl font-thin">
        Amplía el conocimiento de tu marca, gana seguidores e incrementa tus ventas
      </h4>
      <button @click="$emit('start')" class="bg-SFRed focus:outline-none flex justify-center text-lg text-white w-full p-3 rounded-full">
        ¡Comencemos!
      </button>
    </div>
  </div>
</template>

<script>
import Logo from '@/components/logos/logo-white'
export default {
  emits: ['start'],
  components: {
    Logo
  }
}
</script>
